import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'sensMontant'
})
export class SensMontantPipe implements PipeTransform {

  transform(value: string): any {
      if (value == 'C')
        return '+';
      if (value == 'D')
        return '-';
  }

}



// WEBPACK FOOTER //
// ./src/shared/pipes/sensMontant.pipe.ts